import { useMemo } from "react";
import type { FileData, SortOption } from "../../types";
import {
  getFileKey,
  isFileBookmarkedForDisplay,
  orderFilesWithBookmarksFirst,
} from "../../utils/recentFileUtils";

export const useRecentFilesView = ({
  finalFiles = [],
  sortMode = "lastViewed",
  searchQuery = "",
}: {
  finalFiles?: FileData[];
  sortMode?: SortOption;
  searchQuery?: string;
}) => {
  const normalizedQuery = searchQuery.trim().toLowerCase();

  return useMemo(() => {
    const filtered = normalizedQuery
      ? finalFiles.filter((file) => {
          const raw =
            file.title || file.filename || file.name || file.file_name || "";
          const searchTitle = String(raw).toLowerCase().replace(/\.viewr$/, "");
          return searchTitle.includes(normalizedQuery);
        })
      : finalFiles;

    return orderFilesWithBookmarksFirst(filtered, sortMode, (key) => {
      const row = filtered.find((file) => getFileKey(file) === key);
      return row ? isFileBookmarkedForDisplay(row) : false;
    });
  }, [finalFiles, normalizedQuery, sortMode]);
};
